import { useEffect, useState } from "react";

// Keep in sync with $gkit-mobile-max in src/assets/styles/_mixins.scss.
export const MOBILE_MEDIA_QUERY = "(max-width: 767.98px)";

const supportsMatchMedia = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function";

const currentMatch = () =>
  supportsMatchMedia() ? window.matchMedia(MOBILE_MEDIA_QUERY).matches : false;

/**
 * Renders the mobile/desktop split in JS rather than by hiding one side with
 * CSS. The summary is an either/or — hiding it with `d-none` still mounts it,
 * which is how we ended up with two `SubscriptionSummary` trees and a
 * `DiscountCodeField` re-dispatching `addDiscountCode` on expand.
 */
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(currentMatch);

  useEffect(() => {
    if (!supportsMatchMedia()) {
      return;
    }

    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
    const onChange = (event) => setIsMobile(event.matches);

    // Re-sync in case the viewport changed between first render and effect.
    setIsMobile(mediaQuery.matches);

    // Safari < 14 only has the deprecated addListener/removeListener pair.
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", onChange);
      return () => mediaQuery.removeEventListener("change", onChange);
    }

    mediaQuery.addListener(onChange);
    return () => mediaQuery.removeListener(onChange);
  }, []);

  return isMobile;
};

export default useIsMobile;
